import { SearchResults } from "../../Shared/scriptts/interfaces";
import { toggleElement } from "../../Shared/scriptts/rootcomponents/toggle";
import { params, executeSearchUrl, displayResults } from '../search-main';

let eventsApplied = false;

/**
 * Displays the relocation assistance filter
 * @param data The data returned from the search API
 */
export function displayRelocationFilter(data: SearchResults) {
    setRelocationParam();

    document.querySelectorAll<HTMLInputElement>('[name="relocation"]').forEach(elem => {
        const relocationValue = params.RelocationIndicator?.toString();
        elem.checked = (elem.value === 'true' && relocationValue === 'true') || (elem.value === 'false' && relocationValue === 'false');

        if (!eventsApplied) {
            elem.addEventListener('change', () => RelocationOptionChanged(elem));
        }
    });

    if (!eventsApplied) {
        document.querySelector<HTMLButtonElement>('#clear-filters-relocation')?.addEventListener('click', clearButtonClicked);
    }

    setFilterButtonState();
    eventsApplied = true;
}

function setRelocationParam() {
    const clearButton = document.querySelector<HTMLButtonElement>('#clear-filters-relocation');
    const workSiteInputs = document.querySelectorAll<HTMLInputElement>('[name="relocation"]');
    const isFilterSelectable = Array.from(workSiteInputs).some(input => !input.disabled);
    
    if (!isFilterSelectable || params.RelocationIndicator == null) {
        clearButton?.classList.add('hidden');
        return;
    }

    clearButton?.classList.remove('hidden');
}

function RelocationOptionChanged(elem: HTMLInputElement) {
    const filterButton = document.querySelector<HTMLElement>('#filter-button-relocation');

    if (elem.checked && elem.value === 'true') {
        params.RelocationIndicator = true;
    }
    else if (elem.checked && elem.value === 'false') {
        params.RelocationIndicator = false;
    }
    else {
        params.RelocationIndicator = undefined;
    }

    params.Page = '1';
    displayResults(executeSearchUrl, false, true);

    if (!filterButton) {
        return;
    }

    toggleElement(filterButton, false);
}

function clearButtonClicked() {
    params.RelocationIndicator = undefined;
    params.Page = '1';
    document.querySelectorAll<HTMLInputElement>('[name="relocation"]').forEach(elem => elem.checked = false);
    displayResults(executeSearchUrl, false, true);
    document.querySelector<HTMLButtonElement>('#clear-filters-relocation')?.classList.add('hidden');
}

function setFilterButtonState() {
    const filterButton = document.querySelector<HTMLButtonElement>('#filter-button-relocation');
    const filterButtonText = document.querySelector<HTMLElement>('#filter-button-text-relocation');
    const relocationTrueInput = document.querySelector<HTMLInputElement>('#relocation-true');
    const relocationFalseInput = document.querySelector<HTMLInputElement>('#relocation-false');
    let hasFilter = false;

    if (!filterButton || !filterButtonText || !relocationTrueInput || !relocationFalseInput) {
        return;
    }

    if (relocationTrueInput.checked) {
        filterButtonText.textContent = 'Offers relocation assistance';
        hasFilter = true;
    }
    else if (relocationFalseInput.checked) {
        filterButtonText.textContent = 'Does not offer relocation assistance';
        hasFilter = true;
    }
    else {
        filterButtonText.textContent = 'Relocation assistance';
    }

    if (hasFilter) {
        filterButton.classList.add('button-search-filter-applied');
        filterButton.classList.remove('button-search-filter');
        filterButton.querySelectorAll<HTMLElement>('svg').forEach(icon => {
            icon.classList.add('fill-white');
            icon.classList.remove('fill-gray-darkest');
        });
    }
    else {
        filterButton.classList.remove('button-search-filter-applied');
        filterButton.classList.add('button-search-filter');
        filterButton.querySelectorAll<HTMLElement>('svg').forEach(icon => {
            icon.classList.remove('fill-white');
            icon.classList.add('fill-gray-darkest');
        });
    }
}
